import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { formatDate } from '@mcn-platform/models';

/**
 * Export customers to an Excel file (front-end only).
 * @param store The MST store instance (useStore())
 * @param filter Optional filter object for batchLoadFilter
 * @param sort Optional sorting configuration
 */
export default async function exportCustomersXLSX(store: any, filter: any = {}, sort: any = null) {
  const customers = await store.batchLoadFilter(
    store.currentOrganization?.id,
    'customer',
    filter,
    sort,
    [],
    500,
  );

  const dataToDownload = customers.map((cust: any) => {
    const {
      name,
      email,
      createdAt,
      phoneNumber,
      activeMembershipCount,
      text1,
      text2,
      text3,
      text4,
      text5,
    } = cust;

    return {
      Name: name || 'N/A',
      Email: email || 'N/A',
      'Start Date': formatDate(createdAt),
      'Number of Memberships': activeMembershipCount || 0,
      Phone: phoneNumber || 'N/A',
      'Text 1': text1 || '',
      'Text 2': text2 || '',
      'Text 3': text3 || '',
      'Text 4': text4 || '',
      'Text 5': text5 || '',
    };
  });

  const ws = XLSX.utils.json_to_sheet(dataToDownload);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Customers');

  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  saveAs(blob, 'Customer_Report.xlsx');
}
